import { defineStore } from 'pinia';
import { serverUrls } from '../api/constants';
import { useUserStore } from './userStore';
import { callAPI } from '@/api/httpservice';
import { useSocketStore } from './socketStore';

export const useVideoStore = defineStore('video', {
  state: () => ({
    videos: [],
    listPage: 1,
    listLimit: 12,
    listSearch: '',
    totalVideos: 0,
    selectedVideo: null,
    loadingVideo: false,
  }),
  actions: {
    setupVideoListeners() {
      const socketStore = useSocketStore();
      const socket = socketStore.socket;

      if (!socket) {
        console.error('Socket not connected');
        return;
      }

      socket.on('video.created', (data) => {
        this.videos.unshift({
          _id: data.videoId,
          url: data.videoUrl,
        });
        this.totalVideos += 1;
      });

      socket.on('video.deleted', (data) => {
        this.videos = this.videos.filter((p) => p._id !== data.videoId);
      });

      socket.on('video.updated', (data) => {
        const index = this.videos.findIndex((p) => p._id === data._id);
        if (index !== -1) {
          this.videos[index] = {
            ...this.videos[index],
            shotList: data.shotList,
          };
          if (this.selectedVideo && this.selectedVideo._id === data._id) {
            this.selectedVideo = { ...this.selectedVideo, shotList: data.shotList };
          }
        }
      });
    },
    async uploadVideo(videoFile, xmlFile = null, onProgress = null) {
      const userStore = useUserStore();
      const token = userStore.keycloak?.token;

      this.loadingVideo = true;

      const upload = (url, file) =>
        new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          const formData = new FormData();
          formData.append('file', file);

          xhr.open('POST', serverUrls.authUrl + url, true);
          xhr.setRequestHeader('Authorization', 'Bearer ' + token);

          xhr.upload.onprogress = function (event) {
            if (event.lengthComputable && onProgress) {
              onProgress((event.loaded / event.total) * 100, event.loaded, event.total);
            }
          };

          xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
              if (xhr.status >= 200 && xhr.status < 300) {
                resolve(xhr.responseURL);
              } else {
                reject(new Error(xhr.responseText));
              }
            }
          };

          xhr.onerror = function () {
            reject(new Error(`Network error: ${xhr.statusText}`));
          };

          xhr.send(formData);
        });

      try {
        const uploads = [];
        if (videoFile) uploads.push(upload('/video', videoFile));
        if (xmlFile) uploads.push(upload('/xml', xmlFile));
        const results = await Promise.all(uploads);
        return results;
      } finally {
        this.loadingVideo = false;
      }
    },

    async getVideos() {
      return callAPI('GET', `/video?page=${this.listPage}&limit=${this.listLimit}&search=${this.listSearch}`, null)
        .then((res) => {
          this.videos = res.res;
          this.totalVideos = res.count;
        })
        .catch((e) => {
          console.error(e);
        });
    },

    async deleteVideo(fileId) {
      callAPI('DELETE', `/video/${fileId}`).then(() => {
        this.videos = this.videos.filter((video) => video._id !== fileId);
      });
    },

    async retryVideoDescription(fileId) {
      callAPI('PATCH', `/video/${fileId}`);
    },
  },
});
